import { WaitingQueue } from 'owa-promise-queue/lib/WaitingQueue';
import { getGuid } from 'owa-guid';
import {
    SubstrateSearchSuggestionsResponse,
    SubstrateSearchSuggestionsResponsePeopleGroup,
} from 'owa-search-service/lib/data/schema/SubstrateSearchSuggestionsResponse';
import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import FindPeopleResponseMessage from 'owa-service/lib/contract/FindPeopleResponseMessage';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { getSuggestionsService } from './getSuggestionsService';
import convertSuggestionToPersonaType from 'owa-recipient-suggestions/lib/util/convertSuggestionToPersonaType';

const RESOLVE_PENDING_REQUEST_COUNT_THRESHOLD = 3;
const searchSuggestionsQueue = new WaitingQueue<
    SubstrateSearchSuggestionsResponse | FindPeopleResponseMessage
>(RESOLVE_PENDING_REQUEST_COUNT_THRESHOLD);

const isSearchSuggestionsResponse = (
    response: SubstrateSearchSuggestionsResponse | FindPeopleResponseMessage
): response is SubstrateSearchSuggestionsResponse => {
    return (response as any).Groups !== undefined;
};

const isSingleGroup = (group): group is SubstrateSearchSuggestionsResponsePeopleGroup =>
    group.Type === 'People' && group.Suggestions.length === 1;

export async function searchSuggestionsForSinglePersona(
    searchString: string
): Promise<FindRecipientPersonaType> {
    const suggestionsService = getSuggestionsService();

    const correlationId = getGuid();
    const response = await searchSuggestionsQueue.queueTask(() =>
        suggestionsService(
            searchString,
            true, // searchDirectory
            correlationId,
            null, // feedbackManager
            [] // currentRecipients
        )
    );

    if (isSearchSuggestionsResponse(response)) {
        // if we only got one recipient,
        const matchingGroups = response.Groups.filter(isSingleGroup);
        if (matchingGroups.length !== 1) {
            return null;
        }
        const transactionId = response.Instrumentation && response.Instrumentation.TraceId;
        return convertSuggestionToPersonaType(
            matchingGroups[0].Suggestions[0],
            transactionId,
            true // returnMaskedRecipients
        );
    } else {
        if (response.ResultSet.length !== 1) {
            return null;
        }
        const user = response.ResultSet[0];
        return user.EmailAddress !== undefined
            ? (user as (typeof user & { EmailAddress: EmailAddressWrapper }))
            : null;
    }
}
